// USA
export const locale = {
  TRANSLATOR: {
    SELECT: "Select your language"
  },
  MENU: {
    NEW: "new",
    ACTIONS: "Actions",
    CREATE_POST: "Create New Post",
    PAGES: "Pages",
    FEATURES: "Features",
    APPS: "Apps",
    TITLE: "Menu",
    DASHBOARD: {
      TITLE: "Dashboard"
    },
    USER_MANAGEMENT: {
      TITLE: "User management",
      USER: "User",
    },
    PROFILE: {
      TITLE: "profile"
    },
    LOGOUT: {
      TITLE: "Sign out"
    }
  },
  AUTH: {
    TITLE: "CMLC Admin System",
    GENERAL: {
      OR: "Or",
      SUBMIT_BUTTON: "Submit",
      NO_ACCOUNT: "Don't have an account?",
      SIGNUP_BUTTON: "Sign Up",
      FORGOT_BUTTON: "Forgot Password",
      BACK_BUTTON: "Back",
      PRIVACY: "Privacy",
      LEGAL: "Legal",
      CONTACT: "Contact"
    },
    LOGIN: {
      TITLE: "Login Account",
      BUTTON: "Sign In"
    },
    FORGOT: {
      TITLE: "Forgot Password?",
      DESC: "Enter your email to reset your password",
      SUCCESS: "Your account has been successfully reset."
    },
    UPDATE_PASSWORD: {
      TITLE: "New password",
      DESC:
        "The code used to change the password has been sent to your email address.",
      TIME_ALEAT: "Please change password within {second} seconds.",
      TIMEOUT: "Code expired"
    },
    REGISTER: {
      TITLE: "Sign Up",
      DESC: "Enter your details to create your account",
      SUCCESS: "Your account has been successfuly registered.",
      NEW_USER: "New Here?",
      CREATE_ACCOUNT: "Create an Account"
    },
    INPUT: {
      EMAIL: "Email",
      FULLNAME: "Fullname",
      PASSWORD: "Password",
      CONFIRM_PASSWORD: "Confirm Password",
      USERNAME: "Username",
      CODE: "Code",
      NEW_PASSWORD: "New password",
      CONFIRM_NEW_PASSWORD: "Confirm new password",
      SUBMIT: "Submit",
      CANCEL: "Cancel"
    },
    VALIDATION: {
      INVALID: "Field is not valid",
      REQUIRED: "Field is required",
      MIN_LENGTH: "Field minimum length is {min}",
      MAX_LENGTH: "Field maximum length is {max}",
      MIN_MAX_LENGTH:
        "Field minimum length is {min} and maximum length is {max}",
      AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
      NOT_FOUND: "The requested {{name}} is not found",
      INVALID_LOGIN: "The login detail is incorrect",
      REQUIRED_FIELD: "Required field",
      MIN_LENGTH_FIELD: "Minimum field length:",
      MAX_LENGTH_FIELD: "Maximum field length:",
      INVALID_FIELD: "Field is not valid",
      CUSTOM_REQUIRED: "{field} is required"
    }
  },
  PAGE: {
    DEFAULT: {
      TABLE: {
        SEARCH: "Search",
        CLEAR: "clear",
        NEW: "New",
        DATA_NOT_FOUND: "Data not found",
        FIELDS: {
          INDEX: "Index",
          NAME: "Name",
          SWITCH: "Enable",
          ACTION: {
            TITLE: "Action",
            EDIT: "Edit",
            DELETE: {
              TITLE: "Delete",
              DESC: "Confirm data deletion"
            }
          }
        },
        PER_PAGE: "Per page"
      },
      FORM: {
        TITLE: "Form",
        FIELDS: {
          NAME: "Name"
        },
        BTN_SUBMIT: "Submit",
        BTN_OK: "Ok",
        BTN_CANCEL: "Cancel",
        VALIDATION: {
          INVALID: "Field is not valid",
          REQUIRED: "Field is required",
          MIN_LENGTH: "Field minimum length is {min}",
          MAX_LENGTH: "Field maximum length is {max}",
          MIN_MAX_LENGTH:
            "Field minimum length is {min} and maximum length is {max}"
        }
      }
    },
    DASHBOARD: {},
    USER: {
      TABLE: {
        FIELDS: {
          FULLNAME: "Fullname",
          EMAIL: "Email"
        }
      },
      FORM: {
        TABS: {
          DATA: "Data",
          PASSWORD: "Password"
        },
        FIELDS: {
          FULLNAME: "Fullname",
          EMAIL: "Email",
          USER_TYPE: "User type",
          COMPANY: "Company",
          PASSWORD: "Password",
          CONFIRM_PASSWORD: "Confirm password",
          OLD_PASSWORD: "Old password",
          NEW_PASSWORD: "new passwprd",
          CONFIRM_NEW_PASSWORD: "Confirm new password"
        }
      }
    },
    PROFILE: {
      TABLE: {
        FIELDS: {
          FULLNAME: "Fullname",
          EMAIL: "Email"
        }
      },
      FORM: {
        TABS: {
          DATA: "Data",
          PASSWORD: "Password"
        },
        FIELDS: {
          FULLNAME: "Fullname",
          EMAIL: "Email",
          OLD_PASSWORD: "Old password",
          NEW_PASSWORD: "new password",
          CONFIRM_NEW_PASSWORD: "Confirm new password"
        }
      }
    }
  },
  RESPONSE_MESSAGE: {
    USER_NOT_FOUND: "User not found",
    EMAIL_DUPICATE: "This email has already been used.",
    CODE_EXPIRED: "Code expired",
    SUCCESS_TO_SAVE_DATA: "Success to save data",
    FAIL_TO_SAVE_DATA: "Failed to save data",
    SUCCESS_TO_DELETE_DATA: "Success to delete data",
    FAIL_TO_DELETE_DATA: "Failed to delete data",
    DATA_INVALID: "Incorrect information",
    DATA_NOT_FOUND: "Data not found",
    DATA_DUPICATE: "Data dupicate",
    SUCCESS_TO_SAVE_NEW_PASSWORD: "Success to save new password"
  },
  LOADING: "loading"
};
